import React, { Component } from 'react';
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import * as Constants from '../Global/constants';
import { matchPath,withRouter } from 'react-router-dom';
import {SidebarWrapper} from './Sidebar.style';

import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,removeHtmlTags} from '../Global/commonFunctions';

let userDetails = "";
let themeSettings = getThemeSettingsVariables();
class AuditeeSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyLogo: "",
        };
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.setState({ companyLogo: userDetails.companyLogo || "" });
    }

    componentDidUpdate(){
        themeSettings = getThemeSettingsVariables();
    }
    /********************** API CALLS **********************/

    render() {
        let fullName = (userDetails.firstName || "") + " " + (userDetails.lastName || "");
        let initialIcon = fullName.trim().split(" ").filter(n => n).map(name => name[0]).join('').toUpperCase();

        return(
            <Router>
                <SidebarWrapper
                    sidebarBg = {themeSettings.sidebarBg}
                    sidebarBorderRight = {themeSettings.sidebarBorderRight}
                    sidebarTextColor={themeSettings.sidebarTextColor}
                    sidebarIconColor={themeSettings.sidebarIconColor}
                    sidebarSelectedItemBg={themeSettings.sidebarSelectedItemBg}
                    sidebarSelectedItemTextColor={themeSettings.sidebarSelectedItemTextColor}
                    sidebarSelectedItemIconColor={themeSettings.sidebarSelectedItemIconColor}
                    sidebarHoverItemBg={themeSettings.sidebarHoverItemBg}
                    sidebarHoverItemTextColor={themeSettings.sidebarHoverItemTextColor}
                    sidebarHoverItemIconColor={themeSettings.sidebarHoverItemIconColor}
                    themeColor={themeSettings.themeColor}
                >
                    <div className="vertical-menu-wrapper-type1">
                        <div className="vertical-menu-content-type1">
                            <div className="verticalmenu-close">
                                <span className="material-icons">close</span>
                            </div>
                            <div className="vertical-menu-col-type1">
                                <div className="vertical-menu-profile-type1">
                                    <div className="client-profile-bg-type1">
                                        {
                                            isEmptyVariable(this.state.companyLogo)
                                            ? <img className="logo-type1" src="/assets/images/client-logo.png" alt="" />
                                            : <img className="logo-type1" src={Constants.ImageBaseUrl + this.state.companyLogo} alt="" />
                                        }
                                        <div className="client-profile-type1">
                                            <h6 className="m-b-0">
                                                {isEmptyVariable(userDetails) ? "" : removeHtmlTags(userDetails.firstName) + " " + removeHtmlTags(userDetails.lastName)}
                                            </h6>
                                        </div>
                                    </div>
                                    <div className="account_circle">
                                        <h6>{initialIcon}</h6>
                                    </div>
                                    <hr
                                        style={{background:`rgba(${ themeSettings.sidebarDividerColor.r }, ${ themeSettings.sidebarDividerColor.g }, ${ themeSettings.sidebarDividerColor.b }, ${ themeSettings.sidebarDividerColor.a })`}}
                                    />
                                </div>
                                <div className="vertical-menu-list-col-type1">
                                    <div className="vertical-menu-list-type1">
                                        <ul>
                                            {
                                                <li
                                                className={matchPath(this.props.history.location.pathname, { path: ["/auditeedraftassignmentreport","/auditeeemployeedraftobservations","/auditeeemployeedrafttasks"] }) ? "active" : ""}>
                                                    <a href={Constants.URL_AUDITEE_DRAFT_ASSIGNMENT_REPORT}><span className="material-icons-outlined">insert_chart</span> <p>Reports</p></a>
                                                </li>
                                            }
                                            <li>
                                                <a href="/logout"><span className="material-icons-outlined">exit_to_app</span> <p>Logout</p></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </SidebarWrapper>
            </Router>
        );
    }
}

export default withRouter(AuditeeSidebar);